import request from '@/utils/request'

export function login (account, random, sign, imgValidateCode) {
  return request({
    url: '/api/merchant/account/login',
    method: 'post',
    data: {
      account,
      random,
      sign,
      imgValidateCode
    }
  })
}

export function register (query) {
  return request({
    url: '/api/merchant/account/register',
    method: 'post',
    data: query
  })
}

export function checkMobile (query) {
  return request({
    url: '/api/merchant/account/mobile_unique',
    method: 'post',
    data: query
  })
}

export function checkEmail (query) {
  return request({
    url: '/api/merchant/account/email_unique',
    method: 'post',
    data: query
  })
}

export function checkAccount (account) {
  return request({
    url: '/api/merchant/account/account_unique?account=' + account,
    method: 'post'
  })
}

export function setPassword (mobile, password, validateCode) {
  return request({
    url: '/api/merchant/account/setPassword',
    method: 'post',
    data: {
      mobile,
      password,
      validateCode
    }
  })
}

export function updateBusinessInfo (query) {
  return request({
    url: '/api/merchant/business-ext-info/save',
    method: 'post',
    data: query
  })
}



// WEBPACK FOOTER //
// ./src/services/login.js